import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { perfLog } from './perfLog';
// Imported first and for its side effects only — attaches the static
// preloader's event listeners before React even mounts. See that file for
// why this replaced SlotUI's own <Preloader/> for this shell.
import './initialPreloaderBridge';
import './fonts.css';
import './styles.css';
import './demo.css';

perfLog('main.tsx executing');

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
